import { Box, Divider, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SmsIcon } from "../../assets/constants";
import CallIcon from "../../icons/CallIcon";
import { LoadingButton } from "@mui/lab";
import AlertMessage from "../../common/AlertMessage";
import { useDispatch } from "react-redux";
import {
  resetInactiveReminder,
  resetPendingReminder,
  sendInactiveEmailReminderFunc,
  sendPendingEmailReminderFunc,
} from "../../actions/AppConfig";
import { useSelector } from "react-redux";
import IconLegendsBox from "../IconLegendsBox";

const AppContactDetailCard = ({
  status,
  patientId,
  patientContactNumber,
  patientEmail,
}) => {
  const dispatch = useDispatch();
  const sendInactiveEmailReminder = useSelector(
    (state) => state.sendInactiveEmailReminder
  );
  const { loading, error, sentEmailReminder } = sendInactiveEmailReminder;
  const sendPendingEmailReminder = useSelector(
    (state) => state.sendPendingEmailReminder
  );
  const {
    loading: loadingPending,
    error: errorPending,
    sentPendingEmail,
  } = sendPendingEmailReminder;

  const [openAlertMessage, setOpenAlertMessage] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlertMessage(false);
  };

  // const sendInactiveReminderHandler = () => {
  //   let patientObj;
  //   if (status === "inactive") {
  //     patientObj = {
  //       patient_id: patientId,
  //     };
  //     dispatch(sendInactiveEmailReminderFunc(patientObj));
  //   } else {
  //     patientObj = {
  //       patient_id: patientId,
  //     };

  //     dispatch(sendPendingEmailReminderFunc(patientObj));
  //   }
  // };

  useEffect(() => {
    if (sentPendingEmail?.ok) {
      setOpenAlertMessage(true);
      dispatch(resetPendingReminder());
    }
  }, [sentPendingEmail]);

  useEffect(() => {
    if (sentEmailReminder?.ok) {
      setOpenAlertMessage(true);
      dispatch(resetInactiveReminder());
    }
  }, [sentEmailReminder]);

  return (
    <>
      {openAlertMessage && (
        <AlertMessage
          message={
            patientContactNumber && patientEmail
              ? "Reminder email and text sent."
              : "Reminder text sent."
          }
          severity="success"
          open={openAlertMessage}
          handleClose={handleClose}
        />
      )}

      <Stack borderRadius="4px" gap="8px">
        <Stack gap="12px">
          {(patientEmail || patientContactNumber) && (
            <Typography variant="body1" fontWeight={500}>
              Contact Details
            </Typography>
          )}
          {patientEmail && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap="6px"
            >
              <Box display="flex" alignItems="flex-start" gap="6px">
                <SmsIcon />
                <Typography variant="body2" color="#212121">
                  Email Address
                </Typography>
              </Box>

              <Typography variant="body2" color="#707070">
                {patientEmail}
              </Typography>
            </Box>
          )}
        </Stack>
        {patientContactNumber && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap="6px"
          >
            <Box display="flex" alignItems="flex-start" gap="6px">
              <CallIcon />
              <Typography variant="body2" color="#212121">
                Phone Number
              </Typography>
            </Box>

            <Typography variant="body2" color="#707070">
              {patientContactNumber}
            </Typography>
          </Box>
        )}
      </Stack>

      <Divider />

      <IconLegendsBox />

      {/* <Box
          display="flex"
          alignItems="center"
          gap="8px"
          justifyContent="space-between"
        >
          <LoadingButton
            onClick={sendInactiveReminderHandler}
            loading={loading || loadingPending}
            fullWidth
            variant="contained"
            sx={{ textTransform: "uppercase" }}
          >
            {patientEmail ? "Send Email & Text Reminder" : "Send Text Reminder"}
          </LoadingButton>
        </Box> */}
    </>
  );
};

export default AppContactDetailCard;
